import { Configuration } from "./Configuration";
import { Product } from "./Product";

export const STATE_TRANSLATOR = {
  draft: "Borrador",
  signed: "Emitida",
  sent: "Enviada",
  sent_via_mail: "Enviada por mail",
  paid: "Pagado",
  lost_connection: "Conexión perdida",
  rejected: "Rechazada",
  b_rejected: "Rechazado",
  error: "Error",
  issued: "Emitido",
  accepted: "Aceptado",
  invoiced: "Facturado",
  b_sent: "Enviado"
};

export const PAYMENT_STATE_TRANSLATOR = {
  unpaid: "No pagada",
  paid: "Pagada",
  partially_paid: "Parcialmente pagada",
  overpaid: "Sobrepagada",
  overdue: "Vencida",
  pending: "Pendiente",
  rectified: "Rectificada",
  remitted: "Remesada",
};

export const PAYMENT_MEANS_OPTIONS = [
  { value: '00', text: '' },
  { value: '01', text: 'Al contado' },
  { value: '02', text: 'Recibo domiciliado' },
  { value: '03', text: 'Recibo' },
  { value: '04', text: 'Transferencia' },
  { value: '05', text: 'Letra aceptada' },
  { value: '06', text: 'Crédito documentario' },
  { value: '07', text: 'Contrato adjudicación' },
  { value: '08', text: 'Letra de cambio' },
  { value: '09', text: 'Pagaré a la orden' },
  { value: '10', text: 'Pagaré no a la orden' },
  { value: '11', text: 'Cheque' },
  { value: '12', text: 'Reposición' },
  { value: '13', text: 'Especiales' },
  { value: '14', text: 'Compensación' },
  { value: '15', text: 'Giro postal' },
  { value: '16', text: 'Cheque conformado' },
  { value: '17', text: 'Cheque bancario' },
  { value: '18', text: 'Pago contra reembolso' },
  { value: '19', text: 'Pago mediante tarjeta' },
  { value: '13_1', text: 'PayPal' },
  { value: '13_2', text: 'Confirming' }
];

// Object with 'value' as keys and 'text' as values { '00' : '', '01' : 'Al contado', ... } 
export const PAYMENT_MEANS_CODE_TEXT = Object.fromEntries(PAYMENT_MEANS_OPTIONS.map( obj => [obj.value, obj.text] ))

export const PAYMENT_MEANS_MESSAGES: Record<string, string> = {
  '00': '',
  '01': 'Pago al contado',
  '02': 'Pago por recibo domiciliado',
  '03': 'Pago por recibo',
  '04': 'Pago por transferencia',
  '05': 'Pago por letra aceptada',
  '06': 'Pago por crédito documentario',
  '07': 'Pago por contrato de adjudicación',
  '08': 'Pago por letra de cambio',
  '09': 'Pago por pagaré a la orden',
  '10': 'Pago por pagaré no a la orden',
  '11': 'Pago por cheque',
  '12': 'Pago por reposición',
  '13': 'Pago por medios especiales',
  '14': 'Pago por compensación',
  '15': 'Pago por giro postal',
  '16': 'Pago por cheque conformado',
  '17': 'Pago por cheque bancario',
  '18': 'Pago contra reembolso',
  '19': 'Pago mediante tarjeta',
  '13_1': 'Pago por PayPal',
  '13_2': 'Pago por Confirming'
};

export function getPaymentMeansMessage(code: string): string {
  return PAYMENT_MEANS_MESSAGES[code] ?? '';
}


export const recargo_rates = {0.052:0.21, 0.014:0.1, 0.005:0.04}
export class Tax {
    rate: number;
    base: number;
    amount: number;
    recargo_rate?: number;
    recargo_amount?: number;

    constructor(rate: number, base: number, amount: number, recargo_rate?: number, recargo_amount?: number) {
        this.rate = rate;
        this.base = base;
        this.amount = amount;
        this.recargo_rate = recargo_rate;
        this.recargo_amount = recargo_amount;
    }
}

export class ExtraAmount {
  reason: string;
  amount?: number;
  rate?: number;

  constructor(reason: string, amount?: number, rate?: number) {
      this.reason = reason;
      this.amount = amount;
      this.rate = rate;
  }
}

export class ReceiverInfo {
  budget_number: string = '';
  budget_date: string  = '';

  constructor(budget_number: string='', budget_date: string='') {
    this.budget_number = budget_number;
    this.budget_date = budget_date;
  }
}

export class RepresentationData {
  client_name: string = '';
  client_nif: string = '';
  municipality: string = '';
  street: string = '';
  number: string = '';

  constructor(
    client_name: string = '',
    client_nif: string = '',
    municipality: string = '',
    street: string = '',
    number: string = ''
  ) {
    this.client_name = client_name;
    this.client_nif = client_nif;
    this.municipality = municipality;
    this.street = street;
    this.number = number;
  }

  clone(): RepresentationData {
    return new RepresentationData(
      this.client_name,
      this.client_nif,
      this.municipality,
      this.street,
      this.number
    );
  }

  static fromPrimitive(dict: any): RepresentationData {
    return new RepresentationData(
      dict?.client_name ?? '',
      dict?.client_nif ?? '',
      dict?.municipality ?? '',
      dict?.street ?? '',
      dict?.number ?? ''
    );
  }

  toPrimitive(): any {
    return {
      client_name: this.client_name,
      client_nif: this.client_nif,
      municipality: this.municipality,
      street: this.street,
      number: this.number
    };
  }
}

export class SenderInfo {
  budget_number: string = '';
  budget_date: string = '';

  constructor(budget_number: string='', budget_date: string='') {
    this.budget_number = budget_number;
    this.budget_date = budget_date;
  }
}


export class AdditionalInformation {
  sender_info : SenderInfo = new SenderInfo();
  receiver_info: ReceiverInfo = new ReceiverInfo();
  delivery_note_number: string = '';
  delivery_note_date: string = '';
  additional_line_information: string = '';
  record_reference?: string = '';
  record_reference_date?: string = '';

  constructor(sender_info: SenderInfo, receiver_info: ReceiverInfo, delivery_note_number: string, delivery_note_date: string, additional_line_information: string = '', record_reference?: string, record_reference_date?: string) {
    this.sender_info = sender_info;
    this.receiver_info = receiver_info;
    this.delivery_note_number = delivery_note_number;
    this.delivery_note_date = delivery_note_date;
    this.additional_line_information = additional_line_information;
    this.record_reference = record_reference;
    this.record_reference_date = record_reference_date;
  }
}

export class ExtraFieldValue {
    name: string;
    value: string;
    key: string;

    constructor(name: string, value: string, key: string) {
        this.name = name;
        this.value = value;
        this.key = key;
    }
}

export interface InvoiceLineParams {
  // Required fields
  description: string;
  quantity: number;
  unit_price_without_tax: number;
  total_cost: number;
  gross_amount: number;
  taxes: Tax[];

  // Optional fields
  taxes_withheld?: Tax[];
  id?: number;
  selected_retention?: any;
  selected_tax?: any;
  selected_product?: Product;
  product_code?: string;
  selected_tax_event?: string;
  special_taxable_event?: Object;
  additional_information?: AdditionalInformation;
  discounts?: ExtraAmount[];
  additional_fields?: ExtraFieldValue[];
}

export class InvoiceLine {
    description: string;
    quantity: number;
    unit_price_without_tax: number;
    total_cost: number;
    gross_amount: number;
    taxes: Tax[];
    taxes_withheld : Tax[];
    selected_retention?:any;
    selected_tax?:any;
    id?: number;
    selected_product?: Product;
    product_code?:string;
    selected_tax_event?: string
    special_taxable_event?: Object;
    additional_information?: AdditionalInformation;
    discounts: ExtraAmount[];
    additional_fields: ExtraFieldValue[];

    constructor(params: InvoiceLineParams) {
        this.description = params.description;
        this.quantity = params.quantity;
        this.unit_price_without_tax = params.unit_price_without_tax;
        this.total_cost = params.total_cost;
        this.gross_amount = params.gross_amount;
        this.taxes = params.taxes;

        this.selected_retention = params.selected_retention ? params.selected_retention : 'na';
        this.selected_tax = (params.selected_tax || params.selected_tax === 0) ? params.selected_tax : 0.21;
        this.taxes_withheld = params.taxes_withheld ? params.taxes_withheld : [];
        this.id = params.id;

        if (params.selected_product) {
          this.selected_product = params.selected_product;
        }

        this.product_code = params.product_code;
        this.selected_tax_event = params.selected_tax_event ? params.selected_tax_event : 'N/A';
        this.special_taxable_event = params.special_taxable_event;
        this.additional_information = params.additional_information;
        this.discounts = params.discounts ? params.discounts : [];
        this.additional_fields = params.additional_fields ? params.additional_fields : [];
    }

    toString(): string {
        return `${this.id} - ${this.description} - ${this.quantity} - ${this.unit_price_without_tax} - ${this.total_cost} - ${this.gross_amount} - ${this.taxes}`;
    }

    clone(): InvoiceLine {
        return new InvoiceLine({
          description: this.description,
          quantity: this.quantity,
          unit_price_without_tax: this.unit_price_without_tax,
          total_cost: this.total_cost,
          gross_amount: this.gross_amount,
          taxes: this.taxes.map(tax => tax),
          taxes_withheld: this.taxes_withheld.map(tax => tax),
          id: this.id,
          selected_retention: this.selected_retention,
          selected_tax: this.selected_tax,
          selected_product: this.selected_product ? this.selected_product.clone() : undefined,
          product_code: this.product_code,
          selected_tax_event: this.selected_tax_event,
          special_taxable_event: this.special_taxable_event,
          additional_information: this.additional_information,
          discounts: this.discounts.map(d => d),
          additional_fields: this.additional_fields.map(f => f)
        });
    }

    iamvalid(has_feat_lines_0: boolean): boolean {
      if (['', null, undefined].includes(this.description) || ((this.quantity==0 || this.unit_price_without_tax == 0) && !has_feat_lines_0)) { // no acceptem linies amb quantity/price a zero si no tenim el permís
        return false;
      }
      return true;
    }

    isEmpty(): boolean {
      return (
        (!this.description || this.description.trim() === "") &&
        this.quantity === 0 &&
        this.unit_price_without_tax === 0 &&
        this.total_cost === 0 &&
        this.gross_amount === 0
      );
    }

    updateLine(): InvoiceLine {
      const actual_round = (value: number) => Math.round(value * 100) / 100;
      let line = this.clone();

      if (line.selected_product) {
          line.product_code = line.selected_product.code
          line.description = line.selected_product.description
          line.unit_price_without_tax = line.selected_product.price
          line.selected_tax = line.selected_product.selected_tax
          line.selected_retention = line.selected_product.selected_retention
          if (line.selected_product.selected_tax == 0.0 && line.selected_product.selected_tax_event) {
              line.selected_tax_event = line.selected_product.selected_tax_event
          }
          if (line.quantity == 0){
              line.quantity = 1
          }
          if (line.selected_product && line.selected_product.additional_fields) {
              line.additional_fields = line.selected_product.additional_fields.map(af => new ExtraFieldValue(af.name, af.value, af.key))
          }
          line.selected_product = null
      }

      let reason = ''
      if (line.selected_tax_event){
        //iva
        if (line.selected_tax_event == 'ISP'){
            reason = 'Inversión del sujeto pasivo en virtud del art 84.Uno de la Ley 37/1992, del IVA.'
            line.special_taxable_event = {code:'01', reason:reason}
        }
        else if (line.selected_tax_event == 'NS'){
            reason  = 'Operación no sujeta a IVA en virtud del art. 7 de la Ley 37/1992, del IVA.'
            line.special_taxable_event = {code:'02', reason:reason}
        }
        else if (line.selected_tax_event == 'EX'){
            reason = 'Operación exenta en virtud del art. 20 de la Ley 37/1992, del IVA.'
            line.special_taxable_event = {code:'01', reason:reason}
        }
        else if(line.selected_tax_event == 'INTRA.'){
            reason = 'Entrega intracomunitaria exenta en virtud del art. 25 de la Ley 37/1992, del IVA.'
            line.special_taxable_event = {code:'01', reason:reason}
        }
        else if(line.selected_tax_event == 'EXPORT.'){
            reason = 'Operación exenta por exportación en virtud del art. 21 de la Ley 37/1992, del IVA.'
            line.special_taxable_event = {code:'01', reason:reason}
        }
        //igic 
        else if (line.selected_tax_event == 'Art. 50'){
          reason  = 'Operación exenta de IGIC en virtud del Art. 50 de la Ley 4/2012.'
          line.special_taxable_event = {code:'01', reason:reason}
        }
        else if (line.selected_tax_event == 'Art. 11'){
          reason  = 'Operación exenta de IGIC en virtud del Art. 11 de la Ley 20/1991.'
          line.special_taxable_event = {code:'01', reason:reason}
        }
        else if (line.selected_tax_event == 'Art. 12'){
          reason  = 'Operación exenta de IGIC en virtud del Art. 12 de la Ley 20/1991.'
          line.special_taxable_event = {code:'01', reason:reason}
        }
        else if (line.selected_tax_event == 'Art. 13'){
          reason  = 'Operación exenta de IGIC en virtud del Art. 13 de la Ley 20/1991.'
          line.special_taxable_event = {code:'01', reason:reason}
        }
        else if (line.selected_tax_event == 'Art. 25'){
          reason  = 'Operación exenta de IGIC en virtud del Art. 25 de la Ley 19/1994.'
          line.special_taxable_event = {code:'01', reason:reason}
        }
        else if (line.selected_tax_event == 'Art. 47'){
          reason  = 'Operación exenta de IGIC en virtud del Art. 47 de la Ley 19/1994.'
          line.special_taxable_event = {code:'01', reason:reason}
        }
        else if (line.selected_tax_event == 'Art. 110'){
          reason  = 'Operación exenta de IGIC en virtud del Art. 110 de la Ley 4/2012.'
          line.special_taxable_event = {code:'01', reason:reason}
        }
        else if (line.selected_tax_event == 'Otros'){
          reason  = 'Operación exenta de IGIC.'
          line.special_taxable_event = {code:'01', reason:reason}
        }
        else{
            line.special_taxable_event = null
        }
      }
      if (line.selected_tax != 0.0){
          line.selected_tax_event = 'N/A'
          line.special_taxable_event = null
      }
      
      line.total_cost = actual_round(line.quantity * line.unit_price_without_tax)
      line.gross_amount = line.total_cost

      let discount = 0

      if (line.discounts.length > 0) {
          if (line.discounts[0].rate > 0) {
              discount = line.total_cost * line.discounts[0].rate / 100
          } else if (line.discounts[0].amount > 0) {
              discount = line.discounts[0].amount
          }
      }

      line.taxes[0].base = line.total_cost - discount

      if (Object.keys(recargo_rates).includes(line.selected_tax.toString())){
          line.taxes[0].rate = recargo_rates[line.selected_tax]
          line.taxes[0].recargo_rate = line.selected_tax
          line.taxes[0].amount = actual_round(line.taxes[0].base * line.taxes[0].rate)
          line.taxes[0].recargo_amount = actual_round(line.taxes[0].base * line.taxes[0].recargo_rate)
      } else {
          line.taxes[0].rate = line.selected_tax
          line.taxes[0].amount = actual_round(line.taxes[0].base * line.taxes[0].rate)
          line.taxes[0].recargo_amount = 0
          line.taxes[0].recargo_rate = null
      }
      // line.taxes[0].base = line.total_cost

      if (line.selected_retention == 'na'){
          line.taxes_withheld = []
      } else {
          let rate = parseFloat(line.selected_retention)
          line.taxes_withheld = [new Tax(rate, line.taxes[0].base, actual_round(line.taxes[0].base*rate))]
      }
      return line
    }
}

export interface PartyParams {
  // Required fields
  id: number;
  company_id: string | number;
  cif: string;
  post_code: string;

  // Optional fields
  type?: string;
  name?: string;
  first_surname?: string;
  second_surname?: string;
  business_name?: string;
  trade_name?: string;
  address?: string;
  city?: string;
  province?: string;
  country?: string;
  email?: string;
  phone?: string;
  website?: string;
  DIRe?: string;
  accounting_office?: string;
  management_body?: string;
  processing_unit?: string;
  proposing_body?: string;
  bank_account_number?: string;
  bic?: string;
  mandate_id?: string;
  mandate_signature_date?: string;
  debit_account?: string;
  payment_means?: string;
  representation_data?: RepresentationData;
  payment_information?: string;
  pdf_language?: string;
  timestamp_modified?: string;
}

export class Party {
  id: number;
  company_id: string|number;
  cif: string;
  post_code: string;
  type?: string;

  name?: string;
  first_surname?: string;
  second_surname?: string;

  business_name?: string;
  trade_name?: string;

  address?: string;
  city?: string;
  province?: string;
  country?: string;
  email?: string;
  phone?: string;
  website?: string;
  DIRe?: string;
  accounting_office?: string;
  management_body?: string;
  processing_unit?: string;
  proposing_body?: string;
  bank_account_number?: string;
  bic?: string;
  mandate_id?: string;
  mandate_signature_date?: string;
  debit_account?: string;
  payment_means?: string;
  payment_information?: string;
  representation_data?: RepresentationData;
  pdf_language?: string;
  timestamp_modified?: string;

  constructor(params: PartyParams) {
    this.id = params.id;
    this.company_id = params.company_id;
    this.cif = params.cif;
    this.post_code = params.post_code;
    this.type = params.type ? params.type : 'juridica';
    this.name = params.name;
    this.first_surname = params.first_surname;
    this.second_surname = params.second_surname;
    this.business_name = params.business_name;
    this.trade_name = params.trade_name;
    this.address = params.address;
    this.city = params.city;
    this.province = params.province;
    this.country = params.country;
    this.email = params.email;
    this.phone = params.phone;
    this.website = params.website;
    this.DIRe = params.DIRe;
    this.accounting_office = params.accounting_office;
    this.management_body = params.management_body;
    this.processing_unit = params.processing_unit;
    this.proposing_body = params.proposing_body;
    this.bank_account_number = params.bank_account_number;
    this.bic = params.bic;
    this.mandate_id = params.mandate_id;
    this.mandate_signature_date = params.mandate_signature_date;
    this.debit_account = params.debit_account;
    this.payment_means = params.payment_means;
    this.representation_data = params.representation_data ? params.representation_data : new RepresentationData();
    this.payment_information = params.payment_information;
    this.pdf_language = params.pdf_language;
    this.timestamp_modified = params.timestamp_modified;
  }
  clone(): Party {
    return new Party({
      id: this.id,
      company_id: this.company_id,
      cif: this.cif,
      post_code: this.post_code,
      type: this.type,
      name: this.name,
      first_surname: this.first_surname,
      second_surname: this.second_surname,
      business_name: this.business_name,
      trade_name: this.trade_name,
      address: this.address,
      city: this.city,
      province: this.province,
      country: this.country,
      email: this.email,
      phone: this.phone,
      website: this.website,
      DIRe: this.DIRe,
      accounting_office: this.accounting_office,
      management_body: this.management_body,
      processing_unit: this.processing_unit,
      proposing_body: this.proposing_body,
      bank_account_number: this.bank_account_number,
      bic: this.bic,
      mandate_id: this.mandate_id,
      mandate_signature_date: this.mandate_signature_date,
      debit_account: this.debit_account,
      payment_means: this.payment_means,
      representation_data: this.representation_data ? this.representation_data.clone() : undefined,
      payment_information: this.payment_information,
      pdf_language: this.pdf_language,
      timestamp_modified: this.timestamp_modified
    });
  }

  fromPrimitive(dict: any): Party {
    return new Party({
      id: dict.id ?? 0,
      company_id: dict.company_id ?? '',
      cif: dict.cif ?? '',
      post_code: dict.post_code ?? '',
      type: dict.type ?? 'juridica',
      name: dict.name ?? '',
      first_surname: dict.first_surname ?? '',
      second_surname: dict.second_surname ?? '',
      business_name: dict.business_name ?? '',
      trade_name: dict.trade_name ?? '',
      address: dict.address ?? '',
      city: dict.city ?? '',
      province: dict.province ?? '',
      country: dict.country ?? '',
      email: dict.email ?? '',
      phone: dict.phone ?? '',
      website: dict.website ?? '',
      DIRe: dict.DIRe ?? '',
      accounting_office: dict.accounting_office ?? '',
      management_body: dict.management_body ?? '',
      processing_unit: dict.processing_unit ?? '',
      proposing_body: dict.proposing_body ?? '',
      bank_account_number: dict.bank_account_number ?? '',
      bic: dict.bic ?? '',
      mandate_id: dict.mandate_id ?? '',
      mandate_signature_date: dict.mandate_signature_date ?? '',
      debit_account: dict.debit_account ?? '',
      payment_means: dict.payment_means ?? '',
      representation_data: dict.representation_data ? RepresentationData.fromPrimitive(dict.representation_data) : undefined,
      payment_information: dict.payment_information ?? '',
      pdf_language: dict.pdf_language ?? '',
      timestamp_modified: dict.timestamp_modified ?? ''
    });
  }

  toPrimitive(party:Party): any {
    return {
      id: party.id ?? 0,
      company_id: party.company_id ?? '',
      cif: party.cif ?? '',
      post_code: party.post_code ?? '',
      type: party.type ?? '',
      name: party.name ?? '',
      first_surname: party.first_surname ?? '',
      second_surname: party.second_surname ?? '',
      business_name: party.business_name ?? '',
      trade_name: party.trade_name ?? '',
      address: party.address ?? '',
      city: party.city ?? '',
      province: party.province ?? '',
      country: party.country ?? '',
      email: party.email ?? '',
      phone: party.phone ?? '',
      website: party.website ?? '',
      DIRe: party.DIRe ?? '',
      accounting_office: party.accounting_office ?? '',
      management_body: party.management_body ?? '',
      processing_unit: party.processing_unit ?? '',
      proposing_body: party.proposing_body ?? '',
      bank_account_number: party.bank_account_number ?? '',
      bic: party.bic ?? '',
      mandate_id: party.mandate_id ?? '',
      mandate_signature_date: party.mandate_signature_date ?? '',
      debit_account: party.debit_account ?? '',
      payment_means: party.payment_means ?? '',
      representation_data: party.representation_data ? party.representation_data.toPrimitive() : new RepresentationData().toPrimitive(),
      payment_information: party.payment_information ?? '',
      pdf_language: party.pdf_language ?? '',
      timestamp_modified: party.timestamp_modified ?? ''
    };
  }
}

export class RectificativeInfo {
  reason?: string;
  invoice_id?: number;
  invoice_number?: string;
  invoice_date?: string;

  constructor(reason?: string, invoice_id?: number, invoice_number?: string, invoice_date?: string) {
    this.reason = reason? reason : "Motivo: Factura rectificativa por diferencias.";
    this.invoice_id = invoice_id;
    this.invoice_number = invoice_number;
    this.invoice_date = invoice_date;
  }

  clone(): RectificativeInfo {
    return new RectificativeInfo(
      this.reason,
      this.invoice_id,
      this.invoice_number,
      this.invoice_date
    );
  }
}

export interface InvoiceableParams {
  // Required fields
  id: number;
  company_id: number;
  total_amount: number;
  total_to_pay: number;
  invoice_number: string;
  invoice_date: string;
  lines: InvoiceLine[];

  // Optional fields with defaults
  state?: string;
  kind?: string;
  payment_means?: string;
  payment_information?: string;
  flag_payment_means_modified?: boolean;
  flag_payment_information_modified?: boolean;
  qr_url?: string;
  total_gross_amount?: number;
  total_lines_discounts?: number;
  total_gross_amount_before_tax?: number;
  total_tax_amount?: number;
  total_withheld_amount?: number;

  // Optional fields without defaults
  type?: string;  // Type of invoiceable (invoice, budget, delivery_note, proforma, etc.)
  other_amounts?: number;
  operation_date?: string;
  supplier?: Party;
  customer?: Party;
  invoice_due_date?: string;
  external_invoice_number?: string;
  start_date?: string;
  end_date?: string;
  retention_concept?: string;
  retention_amount?: number;
  total_taxes?: Tax[];
  total_taxes_withheld?: Tax[];
  general_discounts?: ExtraAmount[];
  general_surcharges?: ExtraAmount[];
  reimbursable_expense_concept?: string;
  reimbursable_amounts?: number[];
  signing_time?: string;
  sequence_id?: number;
  predicted_invoice_number?: string;
  payment_state?: string;
  accounting_document_id?: number;
  source_odoc_id?: number;
  rectificative?: boolean;
  rectificative_info?: RectificativeInfo;
  predicted_rectificative_invoice_number?: string;
  tax_type?: string;
  additional_info?: string;
  free_notes?: string;
  recurring_invoice_contract_id?: number;
  is_from_recurring_contract?: boolean;
  related_invoiceable_ids?: number[];
  related_invoiceables_type?: string;
  pending_email_send?: boolean;
  pending_email_error?: string | null;
}

export class Invoiceable {
    id: number;
    company_id: number;
    total_amount: number;
    total_to_pay: number;
    total_gross_amount: number = 0;
    total_lines_discounts: number = 0;
    total_gross_amount_before_tax: number = 0;
    total_tax_amount: number = 0;
    total_withheld_amount: number = 0;
    invoice_number: string;
    invoice_date: string;
    operation_date?: string;
    lines: InvoiceLine[];
    other_amounts?: number;
    total_taxes?: Tax[];
    total_taxes_withheld?: Tax[];
    general_discounts?: ExtraAmount[];
    general_surcharges?: ExtraAmount[];
    reimbursable_expense_concept?:string;
    reimbursable_amounts?: number[];
    supplier: Party;
    customer: Party;
    state: string;
    invoice_due_date?: string;
    external_invoice_number?:string;
    start_date?: string;
    end_date?: string;
    retention_concept?: string;
    retention_amount?: number;
    kind?: string;
    signing_time?: string;
    sequence_id?: number;
    predicted_invoice_number?: string;
    payment_state?: string;
    accounting_document_id?: number;
    source_odoc_id?: number;
    rectificative?: boolean;
    rectificative_info?: RectificativeInfo;
    predicted_rectificative_invoice_number?: string;
    tax_type?: string;
    additional_info?: string;
    free_notes?: string;
    payment_means: string = '00';
    payment_information: string = '';
    recurring_invoice_contract_id?: number;
    is_from_recurring_contract?: boolean;
    related_invoiceable_ids?: number[];
    related_invoiceables_type?: string;
    flag_payment_means_modified: boolean = false;
    flag_payment_information_modified: boolean = false;
    qr_url: string = '';
    pending_email_send?: boolean;
    pending_email_error?: string | null;
    type?: string;  // Type of invoiceable (invoice, budget, delivery_note, proforma, etc.)
    // verifactu_data?: VerifactuData;


    constructor(params: InvoiceableParams) {
        // Required fields
        this.id = params.id;
        this.company_id = params.company_id;
        this.total_amount = params.total_amount;
        this.total_to_pay = params.total_to_pay;
        this.invoice_number = params.invoice_number;
        this.invoice_date = params.invoice_date;
        this.lines = params.lines;

        // Optional fields with defaults
        this.state = params.state !== undefined ? params.state : 'draft';
        this.kind = params.kind !== undefined ? params.kind : 'out_invoice';
        this.payment_means = params.payment_means !== undefined ? params.payment_means : '00';
        this.payment_information = params.payment_information !== undefined ? params.payment_information : '';
        this.flag_payment_means_modified = params.flag_payment_means_modified !== undefined ? params.flag_payment_means_modified : false;
        this.flag_payment_information_modified = params.flag_payment_information_modified !== undefined ? params.flag_payment_information_modified : false;
        this.qr_url = params.qr_url !== undefined ? params.qr_url : '';
        this.total_gross_amount = params.total_gross_amount !== undefined ? params.total_gross_amount : 0;
        this.total_lines_discounts = params.total_lines_discounts !== undefined ? params.total_lines_discounts : 0;
        this.total_gross_amount_before_tax = params.total_gross_amount_before_tax !== undefined ? params.total_gross_amount_before_tax : 0;
        this.total_tax_amount = params.total_tax_amount !== undefined ? params.total_tax_amount : 0;
        this.total_withheld_amount = params.total_withheld_amount !== undefined ? params.total_withheld_amount : 0;

        // Optional fields without defaults
        this.type = params.type;
        this.other_amounts = params.other_amounts;
        this.operation_date = params.operation_date;
        this.supplier = params.supplier;
        this.customer = params.customer;
        this.invoice_due_date = params.invoice_due_date;
        this.external_invoice_number = params.external_invoice_number;
        this.start_date = params.start_date;
        this.end_date = params.end_date;
        this.retention_concept = params.retention_concept;
        this.retention_amount = params.retention_amount;
        this.total_taxes = params.total_taxes;
        this.total_taxes_withheld = params.total_taxes_withheld;
        this.general_discounts = params.general_discounts;
        this.general_surcharges = params.general_surcharges;
        this.reimbursable_expense_concept = params.reimbursable_expense_concept;
        this.reimbursable_amounts = params.reimbursable_amounts;
        this.signing_time = params.signing_time;
        this.sequence_id = params.sequence_id;
        this.predicted_invoice_number = params.predicted_invoice_number;
        this.payment_state = params.payment_state;
        this.accounting_document_id = params.accounting_document_id;
        this.source_odoc_id = params.source_odoc_id;
        this.rectificative = params.rectificative;
        this.rectificative_info = params.rectificative_info;
        this.predicted_rectificative_invoice_number = params.predicted_rectificative_invoice_number;
        this.tax_type = params.tax_type;
        this.additional_info = params.additional_info;
        this.free_notes = params.free_notes;
        this.recurring_invoice_contract_id = params.recurring_invoice_contract_id;
        this.is_from_recurring_contract = params.is_from_recurring_contract;
        this.related_invoiceable_ids = params.related_invoiceable_ids;
        this.related_invoiceables_type = params.related_invoiceables_type;
        this.pending_email_send = params.pending_email_send;
        this.pending_email_error = params.pending_email_error;
        // this.verifactu_data = params.verifactu_data
    }

    clone(): Invoiceable {
        let supplier = this.supplier ? this.supplier.clone() : undefined;
        let customer = this.customer ? this.customer.clone() : undefined;
        return new Invoiceable({
            id: this.id,
            company_id: this.company_id,
            total_amount: this.total_amount,
            total_to_pay: this.total_to_pay,
            invoice_number: this.invoice_number,
            invoice_date: this.invoice_date,
            lines: this.lines.map(line => line.clone()),
            other_amounts: this.other_amounts,
            operation_date: this.operation_date,
            supplier: supplier,
            customer: customer,
            type: this.type
        });
    }
    get_lines_with_additional_descriptions(){
      // les línies amb "is_..." s'escriuran en el pdf ocupant tota l'amplada. 
      let computed_lines = []
      for (let line of this.lines){
          //CAPÇALERA ALBARAN
          if(line.additional_information && (line.additional_information.delivery_note_date||line.additional_information.delivery_note_number)){
            let line0 = {...line}
            line0['is_delivery_note_header'] = true
            const headerExists = computed_lines.some(item => 
              item.is_delivery_note_header && 
              item.additional_information &&
              item.additional_information.delivery_note_number === line.additional_information.delivery_note_number &&
              item.additional_information.delivery_note_date === line.additional_information.delivery_note_date
            );
            if (!headerExists) {
              computed_lines.push(line0); //afegim el header si no estava ja afegit
            }
          }
          if (!line.isEmpty()){
            computed_lines.push(line)
          }
          //INFORMACIÓ ADICIONAL
          if(line.additional_information && line.additional_information.additional_line_information){
            let line2 = {...line}
            line2['is_additional_info'] = true
            computed_lines.push(line2)
          }
      }
      return computed_lines
    }
    compute() {
      const actual_round = (value: number) => Math.round(value * 100) / 100;

      const total_taxes: Tax[] = [];
      let total_lines_discounts = 0;
      // Compute total taxes and discounts - sumando SOLO las bases (no los importes de IVA/IGIC)
      for (const line of this.lines) {
          const quantity = Number(line.quantity);
          if (!isNaN(quantity) && quantity !== 0) {
            let total_tax: Tax | undefined = undefined;
            const line_tax = line.taxes[0];
            for (const t of total_taxes) {
                if (t.rate === line_tax.rate && (t.recargo_rate === line_tax.recargo_rate || (!t.recargo_rate && !line_tax.recargo_rate))) {
                    total_tax = t;
                    break;
                }
            }
            if (!total_tax) {
                total_tax = new Tax(line_tax.rate, 0, 0, line_tax.recargo_rate, 0);
                total_taxes.push(total_tax);
            }

            total_tax.base += line_tax.base ?? 0;
            // NO sumamos line_tax.amount aquí para evitar redondeo acumulado

            if (line.discounts.length > 0) {
              if (line.discounts[0].rate > 0) {
                total_lines_discounts += line.gross_amount * line.discounts[0].rate / 100;
              } else if (line.discounts[0].amount > 0) {
                total_lines_discounts += line.discounts[0].amount;
              }
            }
          }
      }

      // Calcular los importes de IVA/IGIC sobre las bases totales (evita errores de redondeo acumulado)
      // El IVA se calcula sobre la suma de bases por tipo, no sumando IVA/IGICs individuales
      for (const tax of total_taxes) {
        if (tax.recargo_rate) {
          // Si hay recargo de equivalencia, calcular IVA + recargo juntos y redondear UNA sola vez
          // para evitar discrepancias de céntimos por redondeos separados
          const total_tax_with_recargo = tax.base * (tax.rate + tax.recargo_rate);
          const total_rounded = actual_round(total_tax_with_recargo);
          // Calcular el IVA redondeado y el recargo como la diferencia (redondeado para evitar errores de precisión)
          tax.amount = actual_round(tax.base * tax.rate);
          tax.recargo_amount = actual_round(total_rounded - tax.amount);
        } else {
          tax.amount = actual_round(tax.base * tax.rate);
          tax.recargo_amount = 0;
        }
      }

      this.total_taxes = total_taxes;
      this.total_lines_discounts = total_lines_discounts;

      // Compute total withheld taxes - sumando SOLO las bases
      const total_taxes_withheld: Tax[] = [];
      for (const line of this.lines) {
          const quantity = Number(line.quantity);
          if (line.taxes_withheld && line.taxes_withheld.length > 0 && (!isNaN(quantity) && quantity !== 0)) {
              let total_tax: Tax | undefined = undefined;
              const line_tax = line.taxes_withheld[0];
              for (const t of total_taxes_withheld) {
                  if (t.rate === line_tax.rate) {
                      total_tax = t;
                      break;
                  }
              }
              if (!total_tax) {
                  total_tax = new Tax(line_tax.rate, 0, 0);
                  total_taxes_withheld.push(total_tax);
              }

              total_tax.base += line_tax.base ?? 0;
              // NO sumamos line_tax.amount aquí para evitar redondeo acumulado
          }
      }

      // Calcular los importes de retenciones sobre las bases totales
      for (const tax of total_taxes_withheld) {
        tax.amount = actual_round(tax.base * tax.rate);
      }

      this.total_taxes_withheld = total_taxes_withheld;

      // Compute importe de descuento global (solo se aplica al total a pagar, no afecta bases ni IVA)
      const general_discount_amount = this.general_discounts && this.general_discounts.length > 0
        ? this.general_discounts.reduce((acc, d) => acc + (d.amount ?? 0), 0)
        : 0;

      // Compute total amounts
      this.total_gross_amount = actual_round(this.lines.reduce((acc, l) => acc + l.gross_amount, 0));
      // Las bases de this.total_taxes ya incluyen los descuentos de línea (si los hay).
      // El descuento global NO debe aplicarse para recalcular los importes de IVA, por lo que no tocamos this.total_taxes.
      // "Total sin impuestos" es la suma de las bases SIN restar el descuento global.
      this.total_gross_amount_before_tax = actual_round(
        this.total_taxes.reduce((acc, t) => acc + t.base, 0)
      );
      this.total_tax_amount = actual_round(this.total_taxes.reduce((acc, t) => acc + t.amount + (t.recargo_amount ?? 0), 0));
      this.total_withheld_amount = actual_round(this.total_taxes_withheld.reduce((acc, t) => acc + t.amount, 0));
      this.total_amount = actual_round(this.total_gross_amount_before_tax + this.total_tax_amount - this.total_withheld_amount);

      const reimbursable_amounts = this.reimbursable_amounts?.reduce((acc, amt) => acc + amt, 0) ?? 0;
      const ret_amount = this.retention_amount ?? 0;
      // El descuento global se aplica únicamente al total a pagar
      this.total_to_pay = actual_round(this.total_amount + reimbursable_amounts - ret_amount - general_discount_amount);
      
  }

  createRectificativeFromOriginal(original_inv:Invoiceable, invoice_number:string, invoice_date:string, configuration:Configuration): Invoiceable {
    const new_inv = this.clone();
    new_inv.state = 'draft';
    // La fecha se setea al firmar, no al crear
    new_inv.invoice_date = '';
    new_inv.rectificative = true;
    new_inv.tax_type = configuration.tax_type;
    new_inv.rectificative_info = new RectificativeInfo(
        this.rectificative_info?.reason,
        this.rectificative_info?.invoice_id,
        invoice_number,
        invoice_date
    );
    // new_inv.rectificative_reason = this.rectificative_reason;
    new_inv.predicted_invoice_number = this.predicted_invoice_number;
    // new_inv.rectificative_invoice_id = original_inv.id;
    new_inv.predicted_rectificative_invoice_number = this.predicted_rectificative_invoice_number;

    if (original_inv) {
      const original_lines = original_inv.lines;
      const new_lines: InvoiceLine[] = [];
      for (const line of original_lines) {
        const new_line = line.clone();
        new_line.quantity = -new_line.quantity;
        new_line.total_cost = -new_line.total_cost;
        new_line.gross_amount = -new_line.gross_amount;
        new_line.id = undefined;
    
        new_line.taxes = new_line.taxes.map(tax => new Tax(tax.rate, -tax.base, -tax.amount, tax.recargo_rate, -tax.recargo_amount));
        
        new_line.taxes_withheld = new_line.taxes_withheld.map(tax => new Tax(tax.rate, -tax.base, -tax.amount));
        
        new_lines.push(new_line);
      }
      new_inv.lines = new_lines;
      new_inv.customer = original_inv.customer;
      new_inv.supplier = original_inv.supplier;
      new_inv.total_amount = -original_inv.total_amount;
      new_inv.total_to_pay = -original_inv.total_to_pay;
      new_inv.total_gross_amount = -original_inv.total_gross_amount;
      new_inv.total_gross_amount_before_tax = -original_inv.total_gross_amount_before_tax;
      new_inv.total_tax_amount = original_inv.total_tax_amount;
      new_inv.total_withheld_amount = original_inv.total_withheld_amount;
      new_inv.other_amounts = original_inv.other_amounts;
      new_inv.general_discounts = original_inv.general_discounts?.map(d => new ExtraAmount(d.reason, -d.amount, d.rate));
      new_inv.general_surcharges = original_inv.general_surcharges?.map(s => new ExtraAmount(s.reason, -s.amount, s.rate));
      new_inv.reimbursable_amounts = original_inv.reimbursable_amounts?.map(a => -a);
      new_inv.total_taxes = original_inv.total_taxes.map(t => new Tax(t.rate, -t.base, -t.amount, t.recargo_rate, -t.recargo_amount));
      new_inv.total_taxes_withheld = original_inv.total_taxes_withheld.map(t => new Tax(t.rate, -t.base, -t.amount));
      new_inv.retention_amount = -original_inv.retention_amount;
      new_inv.retention_concept = original_inv.retention_concept;
      new_inv.start_date = original_inv.start_date;
      new_inv.end_date = original_inv.end_date;
      new_inv.invoice_due_date = original_inv.invoice_due_date;
      new_inv.rectificative_info.invoice_date = original_inv.invoice_date;
      new_inv.rectificative_info.invoice_number = original_inv.invoice_number;
      new_inv.rectificative_info.invoice_id = original_inv.id;
    }
    return new_inv;
  }
    
}

export class VerifactuData {

  str_xml?: string;
  xml_json?: Record<string, any>;
  hash_code?: string;
  hashed_at?: string;
  verifactu_url?: string;
  qr_url?: string;
  aeat_status?: string;
  verifactu_error_description?: string;
  need_to_send_to_verifactu?: boolean;
  verifactu_provider?: string;
  state?: string; // Estado del envío: not_sent, pending, done, error

  constructor(init?: Partial<VerifactuData>) {
    Object.assign(this, init);
  }
}

export class Invoice extends Invoiceable {
  type: string = 'invoice';
  name: string = 'factura';
  actions: string[] = ['can_send_email', 'can_send_accounting', 'can_send_faceb2b2', 'can_send_face', 'can_download', 'has_paid_state', 'can_sign'];
}

export class RecInv extends Invoiceable {
  type: string = 'recurring_invoice_contract';
  name: string = 'factura';
}

export class Budget extends Invoiceable {
  type: string = 'budget';
  name: string = 'presupuesto';
  actions: string[] = ['can_send_email', 'can_download', 'can_mark_as_accepted_or_rejected'];
}

export class DeliveryNote extends Invoiceable {
  type: string = 'delivery_note';
  name: string = 'albarán';
  actions: string[] = ['can_send_email', 'can_download'];
}
export class Proforma extends Invoiceable {
  type: string = 'proforma';
  name: string = 'proforma';
  actions: string[] = ['can_send_email', 'can_download'];
}
export class Ticket extends Invoiceable {
  type: string = 'ticket';
  name: string = 'ticket';
  actions: string[] = ['can_send_mail', 'can_download'];
}

